import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
export const migrateContractorData = (axios: IAxiosInstance) => {
  return async (body: any) => {
    const response = await axios.noRetry.post<IApiResponse<any>>(
      `/api/migrate-contractor-data`,
      body
    );
    return response.data;
  };
};
